// extracted by mini-css-extract-plugin
export var active = "_2v-2";
export var container = "_2v-0";
export var expired = "_2v-3";
export var hasStatus = "_2v-4";
export var statusChip = "_2v-1";